import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TableError } from '../../types/common';
import {
  TransferAllocateLegacyService,
  Wealthlane_AwardService_Dtos_TransferAllocate_UpdateDesiredTotalSharesDto,
} from '../../services/wealthlane-award-services';

const usePutTransferAllocateLegacyDesiredTotalShares = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void,
  onError: (message: string, errors: TableError[]) => void
): UseMutationResult<Array<any>, unknown, any, unknown> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        TransferAllocateLegacyService.putApiAwardApiAppTransferAllocateLegacyDesiredTotalShares(
          payload
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response) {
          toast.success(
            <ToastComponent label='Success' message={`Desired Total Shares Edited.`} />
          );
          // await queryClient.invalidateQueries('getParticipantBrokerList');
        } else {
          throw {
            message: response?.message,
            errors: response?.errors,
            error: new Error(),
          };
        }
        onClose && onClose();
      },
      onError: (err: any) => {
        console.log('error', err);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePutTransferAllocateLegacyDesiredTotalShares;
